import React, { useContext } from 'react';
import { Button, Image } from 'react-bootstrap';
import inboxLogo from '../../img/logo.jpg';
import { AuthContext } from '../../context/AuthContext';
import './Header.css';

const Header = () => {
  const { user, handleSignout } = useContext(AuthContext);

  return (
    <>
      <Image src={inboxLogo} alt="Inbox logo" />
      <div className="signout">
        {user && <Button onClick={handleSignout}>Signout</Button>}
      </div>
    </>
  );
};

export default Header;
